import { Type } from '@angular/core';

import { getDefaultBaseOptions, BaseSpecOptions } from '../base/options';
import { merge } from '../internals/merge';
import { OptionalsRequired } from '../types';

export interface SpecServiceOptions<S = any> extends BaseSpecOptions {
  service: Type<S>;
}

const defaultServiceOptions: OptionalsRequired<SpecServiceOptions> = {
  ...getDefaultBaseOptions()
};

/**
 * @internal
 */
export function getDefaultServiceOptions<S>(overrides: SpecServiceOptions<S>): Required<SpecServiceOptions<S>> {
  return merge(defaultServiceOptions, overrides) as Required<SpecServiceOptions<S>>;
}
